import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {
    filterDropdown_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";

declare var ko: any;

export class articleReviewHistory_template extends vnTemplate{

    protected savedRulesHistory: filterDropdown_template
    protected getTemplateHtml(): string{

        return /* html */`

            <div class="w-form-body review-items">
                <div class="form-body side">

                    <div class="form-header">
                        <h3 class="form-title" data-bind="text: title"></h3>
                    </div>

                    <div class="form-group review">
                        <ul class="review-list" data-bind="foreach: reviewItems">
                            <li class="review-item">
                                <div><b>Date:</b> <span data-bind="text: new Date(dateCreated.date).toLocaleString()"></span></div>
                                <div><b>Author:</b> <span data-bind="text: user.valnet_user.fullName"></span></div>
                                <div><b>Commentor:</b> <span data-bind="text: reviewerUser.valnet_user.fullName"></span></div>
                                <div><b>Comment:</b> <span data-bind="text: comments"></span></div>
                            </li>
                        </ul>
                    </div>

                    <div class="form-header">
                        <h3 class="form-title title-sensai" data-bind="text: guidelinesTitle"></h3>

                    </div>
                    
                    <!-- ko if: callerName() == 'articles_edit_new' -->

                        <div class="form-group" data-bind="" id="ai-subject-coverage">
                            <div style = "float: left; margin-bottom: 1.5rem">

                            <!-- ko if: hideGenerateSuggestions() == true -->

                                <button class="btn-form" type="button"  data-bind="event: { click: onClickGenerateSuggestions } ">Generate Suggestions</button>
                            <!-- /ko -->
                                <button class="btn-form" type="button"  data-bind="event: { click: onClickGenerateEmbeddings }">Generate Coverage Scores</button>
                            </div>
                            <!-- Only for debugging purposes
                                <h2 class="form-title ">Coverage Score: </h2><h2 class="form-title " data-bind="text: sensaiCoverageScore"></h2>
                                <h2 class="form-title ">Guideline Score: </h2><h2 class="form-title " data-bind="text: contentGuidelineScore"></h2>
                                <h2 class="form-title ">Total Sensai Score: </h2><h2 class="form-title" data-bind="text: totalSensaiScore"></h2> -->
                            <table class="list-results">
                                <thead>
                                    <th><span >Suggestions</span></th>
                                    <th><span >Coverage Score</span></th>
                                    <th><span class="i-sensai-icon">Feedback</span></th>
                                    <th></th>
                                </thead>
                                <tbody data-bind="foreach: subjectCoverage">
                                    <tr class="cursor">
                                        <td><span class="score-indicator" data-bind="style: {
                                            'background-color': similarityScore === null || similarityScore === '' ? '' :
                                            similarityScore >= 0.75 ? '#b9ddc1' :
                                            (similarityScore >= 0.5 ? '#f3e09d' : '#fcb4bb')
                                            }">
                                            </span>
                                            <span data-bind="text: suggestionText, style: { 'font-weight': similarityScore !== null && similarityScore !== '' && similarityScore <= 0.5 ? 'bold' : 'normal' }"></span>
                                        </td>
                                        <td><span class="feedback-score" style="position: static;" data-bind="attr: { id: 'row-' + id }, text: similarityScore !== null && similarityScore !== '' ? (similarityScore >= 0.75 ? 'Covered' : (similarityScore >= 0.5 ? 'Somewhat Covered' : 'Not Covered')) : '',
                                        css: {
                                        'positive-feedback': similarityScore !== null && similarityScore !== '' && similarityScore >= 0.75,
                                        'regular-feedback': similarityScore !== null && similarityScore !== '' && similarityScore >= 0.5 && similarityScore < 0.75,
                                        'negative-feedback': similarityScore !== null && similarityScore !== '' && similarityScore < 0.5
                                        }">
                                        </span>
                                        </td>
                                        <td><select data-bind="
                                        options: ['Reliable', 'Irrelevant Subject', 'Incorrect Score'], value: selectedOption, event: { change: onOptionChanged } "></select></td>
                                        <td style="text-align: center">
                                            <!-- ko if: similarityScore !=null && similarityScore < 0.75 -->
                                                <button class="btn-form" type="button" data-bind="event: { click: $parent.onClickGenerateSingleEmbedding }, visible: similarityScore < 0.75">Re-Test</button>
                                            <!-- /ko -->
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <!-- ko if: hideGenerateSuggestions() != true -->
                            <div class="form-group row" style="justify-content: flex-end; margin:0;">
                                <div style="margin-top: 1.5rem;">
                                    <button id="save-feedback" class="btn-form" style="padding: .5rem 3rem;" type="button" data-bind="event: { click: onClickSaveFeedback }" >Save Feedback</button>
                                </div>
                            </div>
                            <!-- /ko -->
                        </div>
                    <!-- /ko -->

                    <div class="form-group" style="border-top: 1px solid #E5E5E5"></div>
                    <div style="display:flex;align-items:center;justify-content: space-between;flex-direction: row" class="form-group ">
                        <div>
                            <div style="display:flex;align-items:center;flex-direction: row" data-bind="visible: showDropdown() ">
                                <label class="form-label" style="margin:0 10px 0 0">History</label>
                                ${ this.savedRulesHistory.getHtmlBuild() }
                            </div>
                        </div>
                        <div class="form-note">
                            * Indicates that the best practice is Mandatory.
                        </div>


                    </div>

                    <div class="form-group" data-bind="" id="content-guidelines">
                    <!-- ko if: guidelines().length < 1 -->
                        <span>There are no content guidelines for the selected Content Type. Please refer to your managing editor for best practices.</span>
                    <!-- /ko -->
                        <ul class="emaki-card-parent-list" data-bind="foreach: guidelines">
                            <li class="emaki-card">
                                <span class="emaki-card-title" data-bind="text: $data.sectionName"></span>
                                    <ul class="emaki-card-list">
                                    <!-- ko foreach: $data.rules -->
                                        <li class="emaki-card-item" data-bind="css: { 'mandatory': isMandatory, 'rejected': !ruleStatus, 'approved': ruleStatus }">
                                            <span class="icon" data-bind="text: ruleName"></span>
                                            <span class="icon"></span>
                                        </li>
                                    <!-- /ko -->
                                       <!-- <li class="emaki-card-item approved"><span class="icon">SEO description</span><span class="icon"></span></li>
                                        <li class="emaki-card-item approved mandatory"><span class="icon">SEO description</span><span class="icon"></span></li> -->

                                    </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
               `;
    }

    protected initPartial():void{

        this.savedRulesHistory =new filterDropdown_template("savedRulesHistory", this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string{

        return "articleReviewHistory_template";
    }

    protected buildViewModel(): any{
        let self = this;
        return{
            idTemplate: ko.observable(null),
            idBrand: ko.observable(this.caller.getVnAppZone().app.params.idBrand),
            callerName: ko.observable(this.caller._name),
            totalSensaiScore: ko.observable(null),
            sensaiCoverageScore: ko.observable(null),
            contentGuidelineScore: ko.observable(null),
            contentValueScore: ko.observable(null),
            reviewItems: ko.observableArray([]),
            guidelines: ko.observable(""),
            introText: ko.observable(""),
            title: ko.observable("Feedback History"),
            sectionName: ko.observable(""),
            rules: ko.observableArray([]),
            showDropdown: ko.observable(false),
            groupOrder: ko.observableArray(["MetaData","Images","Linking","ContentStructureAndFormatting","EnhancedExperienceFeatures"]),
            guidelinesTitle: ko.observable("Best Practices"),
            subjectCoverage: ko.observableArray([]),
            selectedOption: ko.observable(""),
            hideGenerateSuggestions: ko.observable(true),
            onClickGenerateSuggestions : function (idElement) {
                self.onClickGenerateSuggestions()
            },
            onClickGenerateEmbeddings : function (idElement) {
                self.onClickGenerateEmbeddings()
            },
            onClickGenerateSingleEmbedding : function (data,event) {
                self.onClickGenerateSingleEmbedding(data)
            },
            onClickSaveFeedback : function (idElement) {
                self.onClickSaveFeedback()
            }
        };
    }

    public showDropdown(show: boolean): void {
        this.getTemplateViewModel().showDropdown(show);
    }
    public setReviewItems(reviewItems): void{

        if(Array.isArray(reviewItems)){
            this.getTemplateViewModel().reviewItems(reviewItems);
        }
    }

    public getReviewItems() {

        return this.getTemplateViewModel().reviewItems();
    }

    public setGuidelines(guidelines): void{

        //order the guidelines according to the groupOrder
        //let finalOrder = [];
        let order = this.getTemplateViewModel().groupOrder().map(item => item.toLowerCase().replace(/\s/g, ''));

        guidelines.sort((a, b) => {
            let sectionNameA = a.sectionName.toLowerCase().replace(/\s/g, '');
            let sectionNameB = b.sectionName.toLowerCase().replace(/\s/g, '');

            let indexA = order.indexOf(sectionNameA);
            let indexB = order.indexOf(sectionNameB);

            // If a sectionName is not found in the order, it will get a default high index
            if (indexA === -1) indexA = order.length;
            if (indexB === -1) indexB = order.length;

            return indexA - indexB;
        });

        this.getTemplateViewModel().guidelines(guidelines);
    }

    public getGuidelines(): void{

        return this.getTemplateViewModel().guidelines();
    }

    public setGuidelinesTitle(guidelinesTitle): void{

        this.getTemplateViewModel().guidelinesTitle(guidelinesTitle);
    }

    public getGuidelinesTitle(): void{

        return this.getTemplateViewModel().guidelinesTitle();
    }

    public setTitle(title): void{

        this.getTemplateViewModel().title(title);
    }

    public getTitle(): void{

        return this.getTemplateViewModel().title();
    }

    public setIdTemplate(idTemplate): void{

        this.getTemplateViewModel().idTemplate(idTemplate);
    }

    public getIdTemplate(): void{

        return this.getTemplateViewModel().idTemplate();
    }

    public setIntroText(introText) {

        this.getTemplateViewModel().introText(introText);
    }

    public getTotalSensaiScore() :number
    {
        return this.getTemplateViewModel().totalSensaiScore();
    }

    public setTotalSensaiScore(totalSensaiScore)
    {
        // let coverageScore  = this.getTemplateViewModel().sensaiCoverageScore();
        // let guidelineScore = this.getTemplateViewModel().contentGuidelineScore();
        this.getTemplateViewModel().totalSensaiScore(totalSensaiScore);
        
    }

    public getIntroText() {

       return this.getTemplateViewModel().introText();
    }

    public setSavedFeedbacksHistoryOptions(options): void {
        this.savedRulesHistory.getTemplateViewModel().options([]);
        this.savedRulesHistory.getTemplateViewModel().options(options);
    }

    public getFeedbackHistoryOption() {
        return this.savedRulesHistory.getTemplateViewModel().selectedOption();
    }

    public resetFeedbackHistoryOption() {
        this.savedRulesHistory.setSelectedOption(0);
    }
    public showLoading(): void {

        let form = document.getElementById("content-guidelines");
        form.classList.add("loading");
    }

    public hideLoading(): void {

        let form = document.getElementById("content-guidelines");
        form.classList.remove("loading");
    }

    public showScoreLoading(target): void {
        let score = document.getElementById(target);
        score.classList.add("form-loading");
    }

    public hideScoreLoading(target): void {
        let score = document.querySelector("span.form-loading")

        if(score){
            score.classList.remove("form-loading");
        }
    }

    public showLoadingSubjectCoverage(target): void {

        let form = document.getElementById(target);
        if(form){

            form.classList.add("loading");
        }
    }

    public hideLoadingSubjectCoverage(target): void {
        let form = document.getElementById(target);
        form.classList.remove("loading");
    }
    private onClickGenerateSuggestions() {
        this.caller.getAIContent(true);
    }

    private onClickGenerateEmbeddings() {

        this.caller.getAIScores();
    }

    private onClickGenerateSingleEmbedding(data) {
        let target = "row-"+data.id;
        this.caller.getSingleAIScore(data,target);
    }

    public setSubjectCoverage(subjectCoverage) {

        let self = this;

        if(subjectCoverage){
            this.getTemplateViewModel().hideGenerateSuggestions(false);
            subjectCoverage.forEach(item => {

                if (!item.reliabilityFeedback) {
                    item.selectedOption = ko.observable('Reliable'); // Default value
                }else{
                    item.selectedOption = ko.observable(item.reliabilityFeedback);
                }

                item.onOptionChanged = function(data,event) {

                    self.onOptionChanged(data, event)

                };
            });
            this.getTemplateViewModel().subjectCoverage(subjectCoverage);
            this.getTemplateViewModel().idBrand(this.caller.getVnAppZone().app.params.idBrand);
        }
    }

    public setSingleSubjectCoverage(singleSubjectCoverage) {
        let allSubjectCoverage = this.getTemplateViewModel().subjectCoverage();
        this.getTemplateViewModel().subjectCoverage([]);
        if(singleSubjectCoverage){


            allSubjectCoverage.forEach(item => {

                if (item.id == singleSubjectCoverage[0].id) {
                    item.similarityScore = singleSubjectCoverage[0].similarityScore;
                    item.selectedOption = ko.observable(singleSubjectCoverage[0].reliabilityFeedback); // Default value
                }
            })

            this.getTemplateViewModel().subjectCoverage(allSubjectCoverage);
            this.getTemplateViewModel().idBrand(this.caller.getVnAppZone().app.params.idBrand);
        }
    }

    public onClickSaveFeedback() {

        this.caller.saveFeedback();
    }

    public getSubjectCoverage() {

        let subC = this.getTemplateViewModel().subjectCoverage();

        subC.forEach(item => {

            if(item.selectedOption()){
                item.reliabilityFeedback = item.selectedOption();
            }
        });
        return subC;
    }

    public onOptionChanged(data, event) {
        //find the selected option from the subjuct coverage
        //let subC = this.getTemplateViewModel().subjectCoverage();
        if(data.selectedOption() !== data.reliabilityFeedback){
            document.getElementById("save-feedback").classList.add("highlight");
        }
        //console.log(data);
    }

    public getContentGuidelineScore(): number{
        return this.getTemplateViewModel().contentGuidelineScore();
    }

    public setSensaiCoverageScore(score : number){
        
        this.getTemplateViewModel().sensaiCoverageScore(score);
    }

    public getSensaiCoverageScore(): number{
        return this.getTemplateViewModel().sensaiCoverageScore();
    }

    public setContentGuidelineScore(score : number){        
        this.getTemplateViewModel().contentGuidelineScore(score);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/articleReviewHistory_template.ts